//
import { random, times } from 'lodash'
import Model from '../../models/Model'

//
import ActivateModel from '../../models/Actions/AActivate'
import DeactivateModel from '../../models/Actions/ADeactivate'
import PasswordModel from '../../models/Actions/APassword'
import SendEmailRestorePassModel from '../../models/Actions/ASendEmailRestorePass'
import SuggestAuthCodeModel from '../../models/Actions/ASuggestAuthCode'
import SuggestBarAuthCodeModel from '../../models/Actions/ASuggestBarAuthCode'

/**
 * This class describes a g user.
 *
 * @class      GUser (name)
 */
export default class GUser extends Model {

    // init selected roles
    g_selected_roles = []

    //
    new_password = ''
    new_password_repeat = ''

    /**
     * @description
     * Defines the default includes
     */
    static includes = [
        'hr_employee',
        'hr_employee.hr_employee_available_g_branch_offices',
        'roles',
    ]

    /**
     * @description
     * Activates the object.
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    activate() {
        return this.hasMany(ActivateModel)
    }

    /**
     * @description
     * Deactivates the object.
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    deactivate() {
        return this.hasMany(DeactivateModel)
    }

    /**
     * @description
     * Fetches a suggest auth code.
     *
     * @return     {<type>}  The suggest auth code.
     */
    fetchSuggestAuthCode() {
        return SuggestAuthCodeModel
            .get()
            .then(this.setSuggestAuthCode)
    }

    /**
     * @description
     * Fetches a suggest bar auth code.
     *
     * @return     {<type>}  The suggest bar auth code.
     */
    fetchSuggestBarAuthCode() {
        return SuggestBarAuthCodeModel
            .get()
            .then(this.setSuggestBarAuthCode)
    }

    /**
     * @description
     * { function_description }
     */
    genNewPasssword() {
        this.new_password = this.new_password_repeat = this.genPassword()
    }

    /**
     * @description
     * { function_description }
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    genPassword() {
        return times(8, this.genRandomPassword).join('')
    }

    /**
     * @description
     * { function_description }
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    genRandomPassword() {
        return random(35).toString(36)
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get flag_deactivated() {
        return ! this.flag_activated
    }
    
    /**
     * { property_description }
     *
     * @type       {Array}
     */
    get full_name () {
        return `${this.hr_employee_names} ${this.hr_employee_last_name1} ${this.hr_employee_last_name2}`
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get hr_employee_names() {
        return this.getProperty('hr_employee.names', '')
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get hr_employee_last_name1() {
        return this.getProperty('hr_employee.last_name1', '')
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get hr_employee_last_name2() {
        return this.getProperty('hr_employee.hr_employee_last_name2', '')
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get hr_employee_email () {
        return this.hr_employee.email
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get hr_employee_rut () {
        return this.hr_employee.rut
    }

    /**
     * { lambda_description }
     *
     * @param      {<type>}           item    The item
     * @return     {(Object|string)}  { description_of_the_return_value }
     */
    mapDetailBranchOffice = item => item.id

    /**
     * { function_description }
     *
     * @param      {<type>}  item    The item
     * @return     {<type>}  { description_of_the_return_value }
     */
    mapRoles ( item ) {
        return item.id
    }
    
    /**
     * { function_description }
     *
     * @param      {<type>}  item    The item
     * @return     {<type>}  { description_of_the_return_value }
     */
    mapSelected ( item ) {
        return item
    }

    /**
     * @description
     * { function_description }
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    password() {
        return this.hasMany(PasswordModel)
    }

    /**
     * Resets the object.
     *
     * @return     {Object}  { description_of_the_return_value }
     */
    reset () {
        
        //
        this[ 'rut' ]                   = this.hr_employee.rut
        this[ 'names' ]                 = this.hr_employee.names
        this[ 'last_name1' ]            = this.hr_employee.last_name1
        this[ 'last_name2' ]            = this.hr_employee.last_name2
        this[ 'email' ]                 = this.hr_employee.email
        this[ 'g_branch_office_id' ]    = this.hr_employee.g_branch_office_id
        this[ 'name_case' ]             = this.hr_employee.name_case

        //
        this.g_selected_roles = this.roles.map(this.mapSelected)
        this.g_selected_branch_offices = this.hr_employee ? this.hr_employee.hr_employee_available_g_branch_offices.map(this.mapSelected) : []
        
        //
        return this
    }
    
    /**
     * @description
     * { function_description }
     *
     * @return     {string}  { description_of_the_return_value }
     */
    resource () {
        return 'g_user'
    }

    /**
     * @description
     * Sends an email restore pass.
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    sendEmailRestorePass() {
        return this.hasMany(SendEmailRestorePassModel)
    }

    /**
     * @description
     * Sets the suggest auth code.
     *
     * @param      {<type>}  res     The new value
     */
    setSuggestAuthCode = res => {
        this.auth_code = res.slice().pop().getProperty('auth_code', '')
    }

    /**
     * @description
     * Sets the suggest bar auth code.
     *
     * @param      {<type>}  res     The new value
     */
    setSuggestBarAuthCode = res => {
        this.bar_auth_code = res.slice().pop().getProperty('bar_auth_code', '')
    }

    /**
     * @description
     * Returns a create representation of the object.
     *
     * @return     {<type>}  Create representation of the object.
     */
    toCreate () {

        //
        this.role = this.g_selected_roles.map( this.mapRoles )
        this.available_g_branch_offices = this.g_selected_branch_offices.map(this.mapDetailBranchOffice)

        console.log({ bar_auth_code: this.bar_auth_code })

        //
        return this.clean([
            'available_g_branch_offices',
            'auth_code',
            'bar_auth_code',
            'email',
            'g_branch_office_id',
            'last_name1',
            'last_name2',
            'names',
            'role',
            'rut',
        ])
    }

    toRestorePassword() {

        //
        //this['password'] = this.new_password + ''
        //this['password_repeat'] = this.new_password_repeat + ''

        //console.log(this)

        //
        return this.clean([
            'rut',
            'password',
            'password_repeat',
        ])
    }
    
    /**
     * @description
     * Returns an update representation of the object.
     *
     * @return     {<type>}  Update representation of the object.
     */
    toUpdate () {

        //
        //this.collect('role', 'g_selected_roles', this.mapBranchOffices)

        //
        this.role = this.g_selected_roles.map( this.mapRoles )
        this.available_g_branch_offices = this.g_selected_branch_offices.map(this.mapDetailBranchOffice)

        //
        return this.clean([
            'available_g_branch_offices',
            'auth_code',
            'bar_auth_code',
            'id',
            'email',
            'g_branch_office_id',
            'last_name1',
            'last_name2',
            'names',
            'role',
            'rut',
        ])
    }
}